import { percentText } from "../format";

// One row of a list of shares: a label, a percent as text and a thin bar. The bar is decoration; the percent is the number.

export function ShareBar({ label, share }: Readonly<{ label: string; share: number }>) {
  return (
    <li className="grid gap-1 text-[13px]">
      <span className="flex justify-between gap-3">
        <span>{label}</span>
        <span className="text-muted-foreground">{percentText(share)}</span>
      </span>
      <span aria-hidden="true" className="h-1.5 rounded-full bg-muted">
        <span
          className="block h-1.5 rounded-full bg-primary"
          style={{ width: `${Math.max(2, Math.round(share * 100))}%` }}
        />
      </span>
    </li>
  );
}
